// 📦 Dynamic Stock + ⭐ Reviews Script (Separated)

document.addEventListener("DOMContentLoaded", function () {
  const date = new Date();
  const dayOfYear = Math.floor((date - new Date(date.getFullYear(), 0, 0)) / 86400000);

  // 🛒 Stock Settings
  const productStockData = {
  "legacy-18-blockchain-tee-infinite-network": { base: 1, dailyChange: 1 },
  "legacy-30-surreal-reverie-premium-t-shirt": { base: 2, dailyChange: 1 },
  "legacy-29-the-grandmaster-s-gambit-premium-t-shirt": { base: 3, dailyChange: 1 },
  "legacy-28-oceanic-voyage-premium-t-shirt": { base: 4, dailyChange: 1 },
  "legacy-27-jazz-noir-grand-piano-premium-t-shirt": { base: 5, dailyChange: 1 },
  "legacy-26-tribal-visions-premium-t-shirt": { base: 6, dailyChange: 1 },
  "legacy-25-the-cavalry-charge-premium-t-shirt": { base: 7, dailyChange: 1 },
  "legacy-24-dionysian-bliss-premium-t-shirt": { base: 8, dailyChange: 1 },
  "legacy-23-blooming-smoke-vibrant-elegance-t-shirt": { base: 9, dailyChange: 1 },
  "legacy-21-crypto-jackpot-spin-to-win-t-shirt": { base: 10, dailyChange: 1 },
  "men-s-premium-heavyweight-tee": { base: 11, dailyChange: 1 },
  "legacy-20-zen-horizon-inkflow-premium-t-shirt": { base: 12, dailyChange: 1 },
  "legend-19-lucky-brew-cheers-to-fortune-t-shirt": { base: 13, dailyChange: 1 },
  "aura-luminous-harmony-t-shirt": { base: 14, dailyChange: 1 },
  "inspire-15-magic-vibe-abstract-art-cotton-t-shirt": { base: 15, dailyChange: 1 },
  "legacy-14-spartan-echo-premium-t-shirt": { base: 1, dailyChange: 1 },
  "legacy-12-mystic-warrior-premium-t-shirt": { base: 2, dailyChange: 1 },
  "legacy-12-savage-majesty-premium-t-shirt": { base: 3, dailyChange: 1 },
  "legacy-11-primal-vibes-premium-t-shirt": { base: 4, dailyChange: 1 },
  "legacy-10-celestial-chess-harmony-cotton-t-shirt": { base: 5, dailyChange: 1 },
  "legacy-09-timeless-luxury-t-shirt": { base: 6, dailyChange: 1 },
  "legacy-08-royal-overture-premium-t-shirt-1": { base: 7, dailyChange: 1 },
  "legacy-07-knockout-premium-t-shirt": { base: 8, dailyChange: 1 },
  "legacy-06-prosperity-luxe-premium-t-shirt": { base: 9, dailyChange: 1 },
  "legend-05-nautical-dreams-premium-t-shirt": { base: 10, dailyChange: 1 },
  "legacy-04-wild-dominion-claw-mark-premium-t-shirt": { base: 11, dailyChange: 1 },
  "legacy-03-celestial-horizon-premium-t-shirt": { base: 12, dailyChange: 1 },
  "legend-02-serenity-wildflower-premium-t-shirt": { base: 13, dailyChange: 1 },
  "legend-01-ace-rose-gentleman-tee-bold-elegance": { base: 14, dailyChange: 1 },
  "inspire-29-bold-expression-cotton-t-shirt": { base: 15, dailyChange: 1 },
  "inspire-27-crimson-spirit-golden-blossoms-cotton-t-shirt": { base: 1, dailyChange: 1 },
  "inspire-26-robotic-vision-cotton-t-shirt": { base: 2, dailyChange: 1 },
  "inspire-25-love-beyond-words-cotton-t-shirt": { base: 3, dailyChange: 1 },
  "inspire-25-special-love-formula-grace-cotton-t-shirt": { base: 4, dailyChange: 1 },
  "inspire-23-sweet-delight-grace-cotton-t-shirt": { base: 5, dailyChange: 1 },
  "inspire-22-golden-bloom-grace-cotton-t-shirt": { base: 6, dailyChange: 1 },
  "inspire-21-sweet-wings-grace-cotton-t-shirt": { base: 7, dailyChange: 1 },
  "inspire-20-bossy-giraffe-keep-your-head-up-cotton-t-shirt": { base: 8, dailyChange: 1 },
  "inspire-19-the-queen-of-hearts-grace-cotton-t-shirt": { base: 9, dailyChange: 1 },
  "inspire-18-sweet-drip-dream-cotton-t-shirt": { base: 10, dailyChange: 1 },
  "inspire-17-x-ray-elegance-grace-cotton-t-shirt": { base: 11, dailyChange: 1 },
  "inspire-16-pure-hearts-cotton-t-shirt": { base: 12, dailyChange: 1 },
  "inspire-15-wild-love-cotton-t-shirt": { base: 13, dailyChange: 1 },
  "inspire-14-lucky-noodle-cat-blossom-cotton-t-shirt": { base: 14, dailyChange: 1 },
  "inspire-13-the-statue-the-sip-t-shirt": { base: 15, dailyChange: 1 },
  "inspire-12-grace-in-motion-black-stallion-t-shirt": { base: 1, dailyChange: 1 },
  "inspire-11-ryukon-spirit-grace-cotton-t-shirt": { base: 2, dailyChange: 1 },
  "inspire-11-bold-brilliance-grace-cotton-t-shirt": { base: 3, dailyChange: 1 },
  "inspire-31-dj-mona-groove-cotton-t-shirt": { base: 4, dailyChange: 1 },
  "inspire-9-abstract-fierce-grace-cotton-t-shirt-1": { base: 5, dailyChange: 1 },
  "inspire-8-flourishing-elegance-cotton-t-shirt-1": { base: 6, dailyChange: 1 },
  "inspire-7-queen-of-hearts-grace-cotton-t-shir-1": { base: 7, dailyChange: 1 },
  "inspire-6-eternal-love-elegance-cotton-t-shirt-1": { base: 8, dailyChange: 1 },
  "inspire-5-graceful-bloom-of-elegance-cotton-t-shirt": { base: 9, dailyChange: 1 },
  "inspire-4-blooming-essence-of-creativity-cotton-t-shirt-1": { base: 10, dailyChange: 1 },
  "inspire-3-sweet-horizons-1": { base: 11, dailyChange: 1 },
  "inspire-2-vision-of-the-dragon-t-shirt": { base: 12, dailyChange: 1 },
  "inspire-1-floral-symphony-in-art-t-shirt": { base: 13, dailyChange: 1 }
};


  const productReviewsData = {
    "legacy-18-blockchain-tee-infinite-network": 2444,
    "inspire-31-dj-mona-groove-cotton-t-shirt": 2421,
    "inspire-9-abstract-fierce-grace-cotton-t-shirt-1": 1735,
    "inspire-8-flourishing-elegance-cotton-t-shirt-1": 2042,
    "inspire-7-queen-of-hearts-grace-cotton-t-shir-1": 2147,
    "inspire-6-eternal-love-elegance-cotton-t-shirt-1": 2196,
    "inspire-5-graceful-bloom-of-elegance-cotton-t-shirt": 2145,
    "inspire-4-blooming-essence-of-creativity-cotton-t-shirt-1": 2450,
    "inspire-3-sweet-horizons-1": 2346,
    "inspire-2-vision-of-the-dragon-t-shirt": 2260,
    "inspire-1-floral-symphony-in-art-t-shirt": 2020,
    "legacy-30-surreal-reverie-premium-t-shirt": 2313,
    "legacy-29-the-grandmaster-s-gambit-premium-t-shirt": 2449,
    "legacy-28-oceanic-voyage-premium-t-shirt": 2243,
    "legacy-27-jazz-noir-grand-piano-premium-t-shirt": 2078,
    "legacy-26-tribal-visions-premium-t-shirt": 2004,
    "legacy-25-the-cavalry-charge-premium-t-shirt": 2375,
    "legacy-24-dionysian-bliss-premium-t-shirt": 1630,
    "legacy-23-blooming-smoke-vibrant-elegance-t-shirt": 1964,
    "legacy-21-crypto-jackpot-spin-to-win-t-shirt": 1540,
    "men-s-premium-heavyweight-tee": 1993,
    "legacy-20-zen-horizon-inkflow-premium-t-shirt": 1981,
    "legend-19-lucky-brew-cheers-to-fortune-t-shirt": 1708,
    "aura-luminous-harmony-t-shirt": 1672,
    "inspire-15-magic-vibe-abstract-art-cotton-t-shirt": 2285,
    "legacy-14-spartan-echo-premium-t-shirt": 1743,
    "legacy-12-mystic-warrior-premium-t-shirt": 2407,
    "legacy-12-savage-majesty-premium-t-shirt": 2318,
    "legacy-11-primal-vibes-premium-t-shirt": 1954,
    "legacy-10-celestial-chess-harmony-cotton-t-shirt": 1891,
    "legacy-09-timeless-luxury-t-shirt": 1791,
    "legacy-08-royal-overture-premium-t-shirt-1": 2075,
    "legacy-07-knockout-premium-t-shirt": 1761,
    "legacy-06-prosperity-luxe-premium-t-shirt": 2039,
    "legend-05-nautical-dreams-premium-t-shirt": 2493,
    "legacy-04-wild-dominion-claw-mark-premium-t-shirt": 2339,
    "legacy-03-celestial-horizon-premium-t-shirt": 1612,
    "legend-02-serenity-wildflower-premium-t-shirt": 1571,
    "legend-01-ace-rose-gentleman-tee-bold-elegance": 2042,
    "inspire-29-bold-expression-cotton-t-shirt": 2289,
    "inspire-27-crimson-spirit-golden-blossoms-cotton-t-shirt": 2258,
    "inspire-26-robotic-vision-cotton-t-shirt": 2107,
    "inspire-25-love-beyond-words-cotton-t-shirt": 1524,
    "inspire-25-special-love-formula-grace-cotton-t-shirt": 1557,
    "inspire-23-sweet-delight-grace-cotton-t-shirt": 1938,
    "inspire-22-golden-bloom-grace-cotton-t-shirt": 1695,
    "inspire-21-sweet-wings-grace-cotton-t-shirt": 1768,
    "inspire-20-bossy-giraffe-keep-your-head-up-cotton-t-shirt": 1529,
    "inspire-19-the-queen-of-hearts-grace-cotton-t-shirt": 1747,
    "inspire-18-sweet-drip-dream-cotton-t-shirt": 2226,
    "inspire-17-x-ray-elegance-grace-cotton-t-shirt": 1707,
    "inspire-16-pure-hearts-cotton-t-shirt": 2170,
    "inspire-15-wild-love-cotton-t-shirt": 1804,
    "inspire-14-lucky-noodle-cat-blossom-cotton-t-shirt": 1974,
    "inspire-13-the-statue-the-sip-t-shirt": 2455,
    "inspire-12-grace-in-motion-black-stallion-t-shirt": 1591,
    "inspire-11-ryukon-spirit-grace-cotton-t-shirt": 2118,
    "inspire-11-bold-brilliance-grace-cotton-t-shirt": 1878
  };

  const handle = window.location.pathname.split("/").pop();

  // 🔢 Dynamic Stock Display
  if (productStockData[handle]) {
    const { base, dailyChange } = productStockData[handle];
    const left = ((base + (dayOfYear * dailyChange)) % 15) + 1;
    const soldToday = 50 + (dayOfYear % 10);

    const statsBox = document.createElement('span');
    statsBox.className = "blashk-dynamic-stock";
    statsBox.style.backgroundColor = '#a77b56';
    statsBox.style.color = 'white';
    statsBox.style.fontSize = '11px';
    statsBox.style.padding = '3px 8px';
    statsBox.style.borderRadius = '8px';
    statsBox.style.marginLeft = '10px';
    statsBox.style.display = 'inline-block';
    statsBox.style.opacity = '0.8';
    statsBox.style.fontFamily = 'Montserrat, sans-serif';
    statsBox.style.position = 'relative';
    statsBox.style.top = '-10px';
    statsBox.innerHTML = `🧾 Over ${soldToday} sold today | Only <strong>${left} left</strong>`;

    const shareButton = document.querySelector('[aria-label="Share"]') || document.querySelector('.share-button');
    if (shareButton && shareButton.parentNode) {
      shareButton.parentNode.insertBefore(statsBox, shareButton.nextSibling);
    }
  }

  // ⭐ Rating Stars
  if (productReviewsData[handle]) {
    const baseReviews = productReviewsData[handle];
    const reviews = baseReviews + (dayOfYear * 13);
    const rating = 4.7 + (dayOfYear % 3) * 0.05;
    const formattedRating = Math.min(rating, 5).toFixed(1);

    const ratingBox = document.createElement('div');
    ratingBox.className = "blashk-dynamic-rating";
    ratingBox.style.marginTop = '10px';
    ratingBox.style.opacity = '0.85';
    ratingBox.style.fontFamily = 'Montserrat, sans-serif';
    ratingBox.style.fontSize = '13px';
    ratingBox.style.color = '#000';

    ratingBox.innerHTML = `
      <span style="color: #c1763d; font-size: 16px;">
        ★★★★★
      </span>
      <span style="margin-left: 6px;">
        ${formattedRating} · ‎${reviews.toLocaleString()} reviews
      </span>
    `;

    const priceElement = document.querySelector('.price') || document.querySelector('[data-product-price]');
    if (priceElement && priceElement.parentNode) {
      priceElement.parentNode.insertBefore(ratingBox, priceElement.nextSibling);
    }
  }
});
